import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import { I18nStringValidationSchema } from './i18nString';
import { ReadStatusValidationSchema } from './readStatus';
import { UUIDValidationSchema } from './uuid';
export const UpdateObservationReadStatusValidationSchema = z.object({
    observationId: UUIDValidationSchema,
    userId: UUIDValidationSchema
});
const ObservationValidationSchema = z.object({
    _id: z
        .string()
        .uuid()
        .default(() => uuidv4()),
    variant: I18nStringValidationSchema,
    createdBy: UUIDValidationSchema,
    workshopId: UUIDValidationSchema,
    icon: z.string(),
    body: z
        .string()
        .max(65535, 'Body must be 65535 characters or fewer')
        .optional(),
    coordinates: z
        .array(z.number())
        .length(2, 'Coordinates must be an array of two numbers'),
    created: z.date().default(() => new Date()),
    updated: z
        .date()
        .default(() => new Date())
        .optional(),
    name: z.string().optional(),
    categoryId: z.string(),
    parentId: UUIDValidationSchema.optional(),
    attachments: z.array(UUIDValidationSchema).optional(),
    readStatus: z.array(ReadStatusValidationSchema).optional()
});
// Updated UpdateObservationValidationSchema
const UpdateObservationValidationSchema = z.object({
    _id: UUIDValidationSchema,
    variant: I18nStringValidationSchema.optional(),
    createdBy: UUIDValidationSchema.optional(),
    workshopId: UUIDValidationSchema.optional(),
    icon: z.string(),
    body: z
        .string()
        .max(65535, 'Body must be 65535 characters or fewer')
        .optional(),
    coordinates: z
        .array(z.number())
        .length(2, 'Coordinates must be an array of two numbers')
        .optional(),
    categoryId: z.string(),
    attachments: z.array(UUIDValidationSchema).optional(),
    readStatus: z.array(ReadStatusValidationSchema).optional()
});
export { ObservationValidationSchema, UpdateObservationValidationSchema };
//# sourceMappingURL=observation.js.map